/*----------------------------------------------------------------------------
Import modules
----------------------------------------------------------------------------*/

import DeepMenuController from "scripts/marmalade/classes/deep-menu";

/*----------------------------------------------------------------------------
Major Constants
----------------------------------------------------------------------------*/

const TRANSLATE_ELEMENT = document.querySelector('#google_translate_element');
const CLASSNAMES = {
  item: 'mobile-menu__item',
  link: 'mobile-menu__link'
};
const MODIFIERS = {
  back: 'back',
  main: 'main',
  children: 'children'
};

/*----------------------------------------------------------------------------
Functions
----------------------------------------------------------------------------*/

function createMenuItem() {
  let data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let modifier = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  // Create elements
  const item = document.createElement('div');
  const link = document.createElement('a');

  // Add classes
  item.className = CLASSNAMES.item;
  link.className = CLASSNAMES.link;

  // Add all the modifiers to the link
  if (modifier) link.classList.add([...modifier.split(' ').map(mod => CLASSNAMES.link + '--' + mod)]);

  // If the data has attributes, loop and add them to the link
  if (data.attributes) {
    Object.keys(data.attributes).forEach(key => {
      link.setAttribute(key, data.attributes[key]);
    });
  }

  // Add data
  link.textContent = data.title;
  link.href = data.url;

  // Append the link to the item
  item.appendChild(link);

  // Return the item
  return {
    item,
    link
  };
}
function transition(func) {
  let delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 150;
  if (!func || typeof func != 'function') return;
  menu.classList.add('changing');
  menu.classList.remove('is-open');
  setTimeout(() => {
    func();
    menu.classList.add('is-open');
    menu.classList.remove('changing');
  }, delay);
}

/*----------------------------------------------------------------------------
Document setup
----------------------------------------------------------------------------*/

// Find the mobile menu element
const menu = document.querySelector('.js-mobile-menu');
// Find the menu list
const list = menu.querySelector('.js-mobile-menu__list');
// Find the button that opens the menu
const button = document.querySelector('.js-mobile-menu__toggle');
// The menuset to use for the mobile menu
const menuset = menu.getAttribute('data-menuset') || 'Header';
// Grab the base menu <template> from the list
const base = list.querySelector('template');
// Grab the translate holder
let translateHolder = base.querySelector('.js-mobile-menu__translate');

// Get a copy of the menu data
const MOBILEMENU_DATA = JSON.parse(JSON.stringify(window.MenuSets))[menuset];

// Create a new mobile menu controller
const MobileMenu = new DeepMenuController(MOBILEMENU_DATA);
const back = createMenuItem({
  title: 'Back',
  url: '#'
}, MODIFIERS.back);

// Convert all the top level elements in the baseHTML to an array of dom elements
const baseElements = [...base.content.children];

/*----------------------------------------------------------------------------
Event Listeners
----------------------------------------------------------------------------*/

// When the mobile menu is rendered
MobileMenu.on('render', response => {
  // We are top level when there is no url in the response
  const depth = MobileMenu.getDepth();

  // Set the depth attribute on the menu
  menu.setAttribute('data-depth', depth);

  // Emtpy the list
  list.innerHTML = '';

  // Scroll to the top of the list
  list.scrollTo(0, 0);

  // If we are top level add the base elements
  if (depth === 0) {
    // Append the base elements to the list
    baseElements.forEach(el => list.appendChild(el));

    // Update the translate holder
    translateHolder = list.querySelector('.js-mobile-menu__translate');
  } else {
    list.appendChild(back.item);
  }
  if (MobileMenu.parents.length) {
    // Create a new menu item for the back link
    const {
      item,
      link
    } = createMenuItem(MobileMenu.getParent(), MODIFIERS.main);
    // Append the item to the list
    list.appendChild(item);
  }

  // Loop through the children and add them to the list
  response.forEach(page => {
    const {
      item,
      link
    } = createMenuItem(page);
    list.appendChild(item);

    // If the child has children
    if (page.children.length) {
      // Add the children modifier to the link
      link.classList.add(CLASSNAMES.link + '--' + MODIFIERS.children);
      // Add a click event listener to the link
      link.addEventListener('click', e => {
        e.preventDefault();
        // Transition the menu to the next level
        transition(() => page.callback());
      });
    }
  });
});

// When the back button is clicked
back.link.addEventListener('click', e => {
  e.preventDefault();
  transition(() => MobileMenu.back());
});

// When the button is clicked, open the mobile menu
button.addEventListener('click', e => {
  e.preventDefault();
  MobileMenu.open();
});
menu.addEventListener('click', e => {
  if (e.target === menu) MobileMenu.close();
});
window.addEventListener('keydown', e => {
  if (e.key === 'Escape') MobileMenu.close();
});
MobileMenu.on('open', () => {
  menu.classList.add('is-open');
  menu.tabIndex = 0;
  menu.focus();
  menu.ariaHidden = false;
  const depth = MobileMenu.getDepth();
  ScrollLocker.lock();

  // If we are top level, move the translate element to the top of the list
  if (depth === 0 && TRANSLATE_ELEMENT && translateHolder) translateHolder.appendChild(TRANSLATE_ELEMENT);
});
MobileMenu.on('close', () => {
  menu.classList.remove('is-open');
  menu.tabIndex = -1;
  menu.ariaHidden = true;
  ScrollLocker.unlock();

  // Put the translate element back in the header
  if (TRANSLATE_ELEMENT) TRANSLATE_ELEMENT.original_parent.appendChild(TRANSLATE_ELEMENT);
});

/*----------------------------------------------------------------------------
Render the menu
----------------------------------------------------------------------------*/

// Grab the original parent of the translate element
if (TRANSLATE_ELEMENT) TRANSLATE_ELEMENT.original_parent = TRANSLATE_ELEMENT.parentNode;

// Render the menu
MobileMenu.render();